export const normalizeText = (text: string) => text.replace(/\s+/g, ' ').trim();

export const cleanText = (text: string | undefined | null) =>
  typeof text === 'string' ? text.replace(/_x000D_/g, '\n').trim() : '';
